import clsx from "clsx";
import Grid from "../../common/Grid";
import styles from "./ImageText.module.css";

type Props = {
  className?: string;
  image: string;
  mobile: string;
  alt: string;
  title: string;
  problem: string;
  solution: string;
};

export default function ImageText({
  className,
  image,
  mobile,
  alt,
  title,
  problem,
  solution,
}: Props) {
  return (
    <Grid className={clsx(styles.container, className)}>
      <div className={styles.image}>
        <picture>
          <source media="(max-width: 478px)" srcSet={mobile} />
          <source media="(min-width: 1280px)" srcSet={image} />
          <img src={image} alt={alt} loading="lazy" />
        </picture>
      </div>
      <div className={styles.text}>
        <h4 className={styles.title}>{title}</h4>
        <div className={styles.section}>
          <p className={styles.label}>Problem</p>
          <p className={styles.body}>{problem}</p>
        </div>
        <div className={styles.section}>
          <p className={styles.label}>Solution</p>
          <p className={styles.body}>{solution}</p>
        </div>
      </div>
    </Grid>
  );
}
